import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal
} from '@angular/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { _HttpClient } from '@delon/theme';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-financial-ratio-lang-selection',
  standalone: true,
  imports: [CommonModule, NzSelectModule, FormsModule, NzIconModule],
  templateUrl: './financial-ratio-lang-selection.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FinancialRatioLangSelectionComponent implements OnInit {
  #http = inject(_HttpClient);
  #destroyRef = inject(DestroyRef);

  languages = signal(languages);
  selectedLanguage = signal(this.languages().find(lang => lang.code === 'en')!);
  loading = signal(false);
  selectedLanguageCode = 'en';

  ngOnInit() {
    this.getLanguage();
  }

  onUpdateLang() {
    this.loading.set(true);
    this.#http
      .post('api/userdata', {
        FinancialRatioLang: `${this.selectedLanguage().name}`
      })
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: () => {
          this.loading.set(false);
        }
      });
  }

  getLanguage() {
    this.#http
      .get(`api/userdata?keys=FinancialRatioLang&_silent=true`)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: res => {
          if (Object.keys(res).length > 0) {
            this.selectedLanguage.set(res);
            this.selectedLanguageCode =
              this.languages().find(lang => lang.name === res)?.code || 'en';
          }
        }
      });
  }

  onLanguageChange($event: any) {
    if ($event) {
      this.selectedLanguage.set(
        this.languages().find(lang => lang.code === $event)!
      );
      this.onUpdateLang();
    }
  }
}

const languages = [
  {
    code: 'en',
    name: 'English',
    icon: 'global'
  },
  {
    code: 'ph',
    name: 'Filipino',
    icon: 'global'
  },
  {
    code: 'my',
    name: 'Malay',
    icon: 'global'
  },
  {
    code: 'mm',
    name: 'Myanmar',
    icon: 'global'
  }
];
